(function(){
  'use strict';
  function init(){
    var modal=document.getElementById('bk-size-chart-modal');
    if(!modal)return;
    /* BK_SIZE_MODAL_PORTAL_v1: move the modal to <body> so its position:fixed is not
       trapped by a transformed ancestor (Dawn's .product__info-wrapper.scroll-trigger
       keeps transform:matrix(...) after its slide-in animation, which makes the fixed
       overlay render off-screen while body scroll stays locked -> whole page appears
       frozen with no visible/closable modal). */
    if(modal.parentNode!==document.body){document.body.appendChild(modal);}
    var defaultType=modal.dataset.defaultType||'shoe';
    var defaultGender=modal.dataset.defaultGender||'men';
    var triggers=document.querySelectorAll('[data-bk-open-size-chart]');
    var closes=modal.querySelectorAll('[data-bk-close-size-chart]');
    var typeTabs=modal.querySelectorAll('[data-size-type]');
    var genderTabs=modal.querySelectorAll('[data-size-gender]');
    var panels=modal.querySelectorAll('.bk-size-panel');
    var currentType=defaultType;
    var currentGender=defaultGender;
    function updateActivePanel(){
      panels.forEach(function(p){
        if(p.dataset.panelType===currentType&&p.dataset.panelGender===currentGender){
          p.classList.add('active');
        }else{
          p.classList.remove('active');
        }
      });
      typeTabs.forEach(function(t){t.classList.toggle('active',t.dataset.sizeType===currentType);});
      genderTabs.forEach(function(t){t.classList.toggle('active',t.dataset.sizeGender===currentGender);});
    }
    function openModal(){
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('bk-size-modal-open');
      updateActivePanel();
    }
    function closeModal(){
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('bk-size-modal-open');
    }
    triggers.forEach(function(tr){tr.addEventListener('click',function(e){e.preventDefault();openModal();});});
    closes.forEach(function(btn){btn.addEventListener('click',closeModal);});
    typeTabs.forEach(function(tab){tab.addEventListener('click',function(){currentType=tab.dataset.sizeType;updateActivePanel();});});
    genderTabs.forEach(function(tab){tab.addEventListener('click',function(){currentGender=tab.dataset.sizeGender;updateActivePanel();});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.getAttribute('aria-hidden')==='false'){closeModal();}});
    updateActivePanel();
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
})();
